import * as React from 'react';
import InvoiceHistoryContainer from 'components/plansales/invoice/invoiceHistory/InvoiceHistoryContainer';

const InvoiceHistory = () => {
  return <InvoiceHistoryContainer />;
};

export default InvoiceHistory;
